import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  ExcelImportExcludedEntry,
  ExcelImportExcludedReason,
} from '../excel-import-modal/excel-import-modal.model';

export interface ExcelImportExcludedTableTexts {
  source: string;
  date: string;
  label: string;
  amount: string;
  reason: string;
  reasonLabels: Record<ExcelImportExcludedReason, string>;
}

/** Collapsed list of the rows the backend left out of (or flagged in) an Excel import, for one part or the whole workbook. */
@Component({
  selector: 'lib-excel-import-excluded-table',
  templateUrl: './excel-import-excluded-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class ExcelImportExcludedTableComponent {
  readonly title = input.required<string>();
  readonly entries = input.required<ExcelImportExcludedEntry[]>();
  readonly texts = input.required<ExcelImportExcludedTableTexts>();
}
